import axios from "axios";
import { message, Modal } from "antd";
import { hashHistory } from "react-router";
import UserActions from "actions/user-actions";

// 默认参数配置
axios.defaults.retry = 1;
axios.defaults.retryDelay = 1000;
axios.defaults.timeout = 60000;

// 拦截request,设置全局请求为ajax请求
axios.interceptors.request.use(
  config => {
    const xtoken = Date.parse(new Date());
    // console.log("config", config);

    if (config.method === "get") {
      if (config.url.indexOf("&_k") !== -1) {
        config.url = config.url.replace(/_k=\d{13}$/, `_k=${xtoken}`);
      } else {
        config.url = `${config.url}&_k=${xtoken}`;
      }
    }
    return config;
  },
  error => Promise.reject(error)
);
// 拦截响应response，并做一些错误处理
axios.interceptors.response.use(
  response => {
    if (response.headers["content-type"].indexOf("text/html") !== -1) {
      UserActions.clearUserInfo(() => {
        hashHistory.replace("/farm");
      });
      return Promise.reject();
    }
    const res = response.data;
    if (res.code === 0 && res.data && res.data === null) {
      return Promise.reject(res);
    }
    // console.log("daochu", res);
    if (res.type == "application/vnd.ms-excel") {
      return Promise.reject(res);
    }
    if (res.status === false) {
      return Promise.reject(res);
    }
    if (res.status === true) {
      return Promise.resolve(res);
    }
    if (res.type == "application/json") {
      return Promise.resolve(res);
    }
    switch (res.code) {
      case "200":
      case 0:
        return res;
      case -1:
      // 暂无设备数据
      case 103004019:
      case 103004018:
      case 1000229003:
      case 103004020:
      // 账号密码错误
      case 100021401:
      // 基地未关联设备
      case 103004029:
      // 该角色已关联用户，无法禁用
      case 103004039:
      case 103004130:
      case 103004135:
        return Promise.reject(res);
      // 用户未登录
      case 100010110:
        console.log("用户未登录", res);
        UserActions.clearUserInfo(() => {
          hashHistory.replace("/farm");
        });
        return Promise.reject(res);
      case 103004007:
        Modal.error({
          title: "提示",
          content: res.msg
        });
        return Promise.reject(res);
      default:
        console.log(response.config.alert);
        if (response.config.alert) {
          message.error(res.msg || "操作失败");
        }
        return Promise.reject(res);
    }
  },
  err => {
    console.log("请求错误", err, err.toString() === "Error: Network Error");
    // 处理302跳转404错误,用户未登录=>不准确
    if (err.toString() === "Error: Network Error") {
      UserActions.clearUserInfo(() => {
        hashHistory.replace("/farm");
      });
      return Promise.reject(err);
    }
    if (axios.isCancel(err)) {
      console.log("取消请求");
      err.isCancel = true;
      return Promise.reject(err);
    }

    const { config } = err;
    if (!config || !config.retry) {
      if (err.response.status === 500) {
        message.error("请求服务器超时,请稍后再试!");
      }
      return Promise.reject(err);
    }
    config.retryCount = config.retryCount || 0;
    if (config.retryCount >= config.retry) {
      message.error("请求服务器超时,请稍后再试!");
      return Promise.reject(err);
    }
    config.retryCount += 1;
    const backoff = new Promise(resolve => {
      setTimeout(() => {
        resolve();
      }, config.retryDelay || 1);
    });
    return backoff.then(() => axios(config));
  }
);

const { CancelToken } = axios;
const sources = [];

/**
 * ajax请求
 *
 * @param {String} url 请求路径
 * @param {Object} params 请求参数
 * @param {Object} config Axios配置
 * @param {String} method 请求方法 post or get
 * @param {Boolean} alert 错误是否弹框提示 默认true
 * @returns
 */
const request = (url, params, config, method, alert) => {
  const newConfig = Object.assign(config, {
    cancelToken: new CancelToken(c => {
      sources.push(c);
    }),
    alert
  });
  if (method === "get") {
    // console.log("newConfig", newConfig);
    return axios[method](url, newConfig);
  }
  return axios[method](url, params, newConfig);
};

const post = (url, params, config = {}, alert = true) =>
  request(url, params, config, "post", alert);

const get = (url, params, config = {}, alert = true) =>
  request(url, params, config, "get", alert);

const Axios = {
  post,
  get
};

export { sources, Axios };
